export const getters = {
    appTitle(state) {
        return state.appName
    },
    getUser(state) {
        return state.user
            /*if (state.user.roles[0]) {
                return state.user
            }
            state.user = JSON.parse(localStorage.getItem("UserInfo"));
            return state.user*/
    },
    getError(state) {
        return state.error
    },
    getLoading(state) {
        return state.loading
    },
    getAccessToken(state) {
        if (state.access_token != null) {
            return state.access_token
        }
        state.access_token = localStorage.getItem("AccessToken")
        return state.access_token
    },
    getLang(state) {
        return state.lang
    },
    isAuth(state) {
        return state.isAuth
    },
}